if (!customElements.get('variant-selects')) {

    /**
     *  @class
     *  @function VariantSelects
     */
    class VariantSelects extends HTMLElement {
        constructor() {
            super();
            this.sticky = this.dataset.sticky;
            this.featured = this.dataset.featured;
            this.isDisabledFeature = this.dataset.isDisabled;
            this.addEventListener('change', this.onVariantChange);
            this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
                return selector != this;
            });
        }

        connectedCallback() {
            this.updateOptions();
            this.updateMasterId();
            this.setDisabled();
            /* añadido por Victor el 16.01.24 */
            this.filterImgVariant();
           /* fin de añadido */
        }

        onVariantChange() {
            this.updateOptions();
            this.updateMasterId();
            this.toggleAddButton(true, '', false);
            this.updatePickupAvailability();
            this.removeErrorMessage();
            this.updateVariantText();
            this.setDisabled();
            /* añadido por Victor el 16.01.24 */
            // Seleccionar el elemento
            var p_div = document.querySelector('.thb-product-detail.product');
            // Comprobar si el elemento existe y obtener el valor del atributo
            if (p_div) {
              var pTypeValue = p_div.getAttribute('p-type');
            } else {
              var pTypeValue = 'single';
            }
            if(pTypeValue == 'single') {
              this.filterImgVariant();
            }
           /* fin de añadido */
            if (!this.currentVariant) {
                this.toggleAddButton(true, '', true);
                this.setUnavailable();
            } else {
                this.updateMedia();
                if (!this.featured) {
                    this.updateURL();
                }
                this.updateVariantInput();
                this.renderProductInfo();
                //this.updateShareUrl();
            }
            this.updateOther();
            dispatchCustomEvent('product:variant-change', {
                variant: this.currentVariant,
                sectionId: this.dataset.section
            });
        }
        /* añadido por Victor el 16.01.24 */
        filterImgVariant() {
          var c1 = 0;

          if(this.currentVariant.featured_image && this.currentVariant.featured_image.alt) {
            // mostrar únicamente las imágenes de la variante seleccionada
            document.querySelectorAll('[thumbnail-alt]').forEach(img => img.style.display = 'none')
            const currentImgAlt = this.currentVariant.featured_image.alt
            const thumbnailSelector = `[thumbnail-alt = '${currentImgAlt}']`
            const allSelector = `[thumbnail-alt = 'all']` 
            document.querySelectorAll(thumbnailSelector).forEach(function callback(img) {
              img.style.display = 'block'
              if(c1 == 0) {
                 if(img.style.cssText = 'display:block;grid-column: 1/-1;') {
                   img.sizes = `${img.parentElement.offsetWidth}px`;
                   /*var srcsetActual = img.getAttribute('srcset');
                   img.setAttribute('srcset', '');
                   img.setAttribute('srcset', srcsetActual);*/
                 }

              }
              c1++;
            });
            document.querySelectorAll(allSelector).forEach(function callback(img) {
              img.style.display = 'block';
              c1++;
            });
            document.querySelector('.pagination-progress-bar').style.width = 100 / c1 + '%';
          } else {
            // mostrar todas las imágenes
            document.querySelectorAll('[thumbnail-alt]').forEach(function callback(img) {
              img.style.display = 'block'
              c1++;
            });
          }
          /* Editado por Victor según PH el 31.03.25. Reemplazada siguiente linea por a continuación
          document.querySelector('.pagination-progress-bar').style.width = 100 / c1 + '%';*/
          const progressBar = document.querySelector('.pagination-progress-bar');
          if (progressBar && c1 > 0) {
            progressBar.style.width = 100 / c1 + '%';
          }
          /* fin de Editado */

        }
        /* fin de añadido */
        updateOptions() {
            this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
            this.options = [];
            this.fieldsets.forEach((fieldset, i) => {
                if (fieldset.querySelector('select')) {
                    this.options.push(fieldset.querySelector('select').value);
                } else if (fieldset.querySelectorAll('input').length) {
                    this.options.push(fieldset.querySelector('input:checked').value);
                }
            });
        }

        updateVariantText() {
            const fieldsets = Array.from(this.querySelectorAll('fieldset'));
            fieldsets.forEach((item, i) => {
                let label = item.querySelector('.form__label__value');
                if (label) {
                    label.innerHTML = this.options[i];
                }
            });
        }

        updateMasterId() {
            this.currentVariant = this.getVariantData().find((variant) => {
                return !variant.options.map((option, index) => {
                    return this.options[index] === option;
                }).includes(false);
            });
        }

        updateOther() {
            if (this.dataset.updateUrl === 'false') {
                return;
            }
            if (this.other.length) {
                let fieldsets = this.other[0].querySelectorAll('fieldset'),
                    fieldsets_array = Array.from(fieldsets);
                this.options.forEach((option, i) => {
                    if (fieldsets_array[i].querySelector('select')) {
                        fieldsets_array[i].querySelector(`select`).value = option;
                    } else if (fieldsets_array[i].querySelectorAll('input').length) {
                        fieldsets_array[i].querySelector(`input[value="${option}"]`).checked = true;
                    }
                });
                this.other[0].updateOptions();
                this.other[0].updateMasterId();
                this.other[0].updateVariantText();
                this.other[0].setDisabled();
            }
        }

        updateMedia() {
            /* desactivado porque dejó de funcionar al introducir imágenes de variaciones */
            /* if (!this.currentVariant) return;
             if (!this.currentVariant.featured_media) return;

             const productSlider = document.getElementById(`MediaGallery-${this.dataset.section}`);
             if (!productSlider) return;
             let mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
             let activeMedia = productSlider.querySelector(`[data-media-id="${ mediaId }"]`);

             productSlider.querySelectorAll('[data-media-id]').forEach((element) => {
               element.classList.remove('is-active');
             });
             activeMedia.classList.add('is-active');

             if (this.featured) return;

             activeMedia.parentElement.prepend(activeMedia);

             window.setTimeout(() => {
               activeMedia.parentElement.scrollTo({
                 left: 0,
                 top: 0,
                 behavior: 'smooth'
               });
             });*/
        }

        updateURL() {
            if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
            window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
        }

        updateShareUrl() {
            const shareButton = document.getElementById(`Share-${this.dataset.section}`);
            if (!shareButton) return;
            shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
        }

        updateVariantInput() {
            const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
            productForms.forEach((productForm) => {
                const input = productForm.querySelector('input[name="id"]');
                input.value = this.currentVariant.id;
                input.dispatchEvent(new Event('change', {
                    bubbles: true
                }));
            });
        }

        updatePickupAvailability() {
            const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

            if (!pickUpAvailability) return;

            if (this.currentVariant && this.currentVariant.available) {
                pickUpAvailability.fetchAvailability(this.currentVariant.id);
            } else {
                pickUpAvailability.removeAttribute('available');
                pickUpAvailability.innerHTML = '';
            }
        }

        removeErrorMessage() {
            const section = this.closest('section');
            if (!section) return;

            const productForm = section.querySelector('product-form');
            if (productForm) productForm.handleErrorMessage();
        }

        getSectionsToRender() {
            return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
        }

        renderProductInfo() {
            let sections = this.getSectionsToRender();

            fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
                .then((response) => response.text())
                .then((responseText) => {
                    const html = new DOMParser().parseFromString(responseText, 'text/html');
                    sections.forEach((id) => {
                        const destination = document.getElementById(id);
                        const source = html.getElementById(id);

                        if (source && destination) destination.innerHTML = source.innerHTML;

                        const price = document.getElementById(id);
                        const price_fixed = document.getElementById(id + '--sticky');

                        if (price) price.classList.remove('visibility-hidden');
                        if (price_fixed) price_fixed.classList.remove('visibility-hidden');

                    });
                    this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);

                });
        }

        toggleAddButton(disable = true, text = false, modifyClass = true) {
            const productForm = document.getElementById(`product-form-${this.dataset.section}`);
            if (!productForm) return;

            const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

            if (!submitButtons) return;

            submitButtons.forEach((submitButton) => {
                const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

                if (!submitButtonText) return;

                if (disable) {
                    submitButton.setAttribute('disabled', 'disabled');
                    if (text) submitButtonText.textContent = text;
                } else {
                    submitButton.removeAttribute('disabled');
                    submitButton.classList.remove('loading');
                    submitButtonText.textContent = window.theme.variantStrings.addToCart;
                }
            });

            if (!modifyClass) return;
        }

        setUnavailable() {
            const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
            const price = document.getElementById(`price-${this.dataset.section}`);
            const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

            submitButtons.forEach((submitButton) => {
                const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
                if (!submitButton) return;
                submitButtonText.textContent = window.theme.variantStrings.unavailable;
                submitButton.classList.add('sold-out');
            });
            if (price) price.classList.add('visibility-hidden');
            if (price_fixed) price_fixed.classList.add('visibility-hidden');
        }

        setDisabled() {
            if (this.isDisabledFeature != 'true') {
                return;
            }
            const variant_data = this.getVariantData();


            if (variant_data) {

                const selected_options = this.currentVariant.options.map((value, index) => {
                    return {
                        value,
                        index: `option${index + 1}`
                    };
                });
                const available_options = this.createAvailableOptionsTree(variant_data, selected_options);


                this.fieldsets.forEach((fieldset, i) => {
                    const fieldset_options = Object.values(available_options)[i];

                    if (fieldset_options) {
                        if (fieldset.querySelector('select')) {
                            fieldset_options.forEach((option, option_i) => {
                                if (option.isUnavailable) {
                                    fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                                } else {
                                    fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                                }
                            });
                        } else if (fieldset.querySelectorAll('input').length) {
                            fieldset.querySelectorAll('input').forEach((input, input_i) => {
                                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
                            });
                        }
                    }
                });

            }
            return true;
        }

        createAvailableOptionsTree(variant_data, selected_options) {
            // Reduce variant array into option availability tree
            return variant_data.reduce((options, variant) => {

                // Check each option group (e.g. option1, option2, option3) of the variant
                Object.keys(options).forEach(index => {

                    if (variant[index] === null) return;

                    let entry = options[index].find(option => option.value === variant[index]);

                    if (typeof entry === 'undefined') {
                        // If option has yet to be added to the options tree, add it
                        entry = {
                            value: variant[index],
                            isUnavailable: true
                        };
                        options[index].push(entry);
                    }

                    // Check how many selected option values match a variant
                    const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
                        value,
                        index
                    }) => {
                        return variant[index] === value ? count + 1 : count;
                    }, 0);

                    // Only enable an option if an available variant matches all but one current selected value
                    if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
                        entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
                    }

                    // Make sure if a variant is unavailable, disable currently selected option
                    if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
                        entry.isUnavailable = true;
                    }

                    // First option is always enabled
                    if (index === 'option1') {
                        entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
                    }
                });

                return options;
            }, {
                option1: [],
                option2: [],
                option3: []
            });
        }

        getVariantData() {
            this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
            return this.variantData;
        }
    }

    customElements.define('variant-selects', VariantSelects);

    /**
     *  @class
     *  @function VariantRadios
     */
    class VariantRadios extends VariantSelects {
        constructor() {
            super();
        }

        updateOptions() {
            const fieldsets = Array.from(this.querySelectorAll('fieldset'));
            this.options = fieldsets.map((fieldset) => {
                return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
            });
        }
    }

    customElements.define('variant-radios', VariantRadios);
}
if (!customElements.get('product-slider')) {
    /**
     *  @class
     *  @function ProductSlider
     */
    class ProductSlider extends HTMLElement {
        constructor() {
            super();

        }

        connectedCallback() {
            const _this = this;
            const product_container = this.closest('.thb-product-detail');

            this.pagination = this.parentElement.querySelector('.product-images-buttons');
            this.sliderItems = this.querySelectorAll('[id^="Slide-"]');

            // Start Gallery
            this.addEventListener('change', this.setupProductGallery);
            this.setupProductGallery();

            // Start Pagination

            if (this.pagination) {
                this.setupPagination();
                this.addEventListener('scroll', this.updatePagination.bind(this));
                const resizeObserver = new ResizeObserver(entries => this.onPaginationResize());
                resizeObserver.observe(this);
            }
        }

        setupProductGallery() {
            if (!this.querySelectorAll('.product-single__media-zoom').length) {
                return;
            }
            let activeImages = Array.from(this.querySelectorAll('.product-single__media-image'));

            this.setEventListeners(this, activeImages);
        }

        buildItems(activeImages) {
            let images = activeImages.map((item) => {
                let activelink = item.querySelector('.product-single__media-zoom');
                return {
                    src: activelink.getAttribute('href'),
                    msrc: activelink.dataset.msrc,
                    w: activelink.dataset.w,
                    h: activelink.dataset.h,
                    title: activelink.getAttribute('title')
                };
            });
            return images;
        }

        setEventListeners(container, activeImages) {
            let links = container.querySelectorAll('.product-single__media-zoom'),
                items = container.buildItems(activeImages),
                captionEl = container.dataset.captions,
                pswpElement = document.querySelectorAll('.pswp')[0],
                options = {
                    maxSpreadZoom: 2,
                    loop: false,
                    allowPanToNext: false,
                    closeOnScroll: false,
                    showHideOpacity: false,
                    arrowKeys: true,
                    history: false,
                    captionEl: captionEl,
                    fullscreenEl: false,
                    zoomEl: false,
                    shareEl: false,
                    counterEl: true,
                    arrowEl: true,
                    preloaderEl: true
                };

            links.forEach((link => {        
                        
                link.addEventListener('click', (event) => {
                    let i = link.dataset.index;
                    options.index = parseInt(i, 10);
                    options.getThumbBoundsFn = () => {
                        const thumbnail = link.closest('.product-single__media'),
                            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                            rect = thumbnail.getBoundingClientRect();
                        return {
                            x: rect.left,
                            y: rect.top + pageYScroll,
                            w: rect.width
                        };
                    };
                    if (typeof PhotoSwipe !== 'undefined') {
                        let pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
                        pswp.listen('firstUpdate', function () {
                            pswp.listen('parseVerticalMargin', function (item) {
                                item.vGap = {
                                    top: 50,
                                    bottom: 50
                                };
                            });
                        });
                        pswp.init();
                    }
                    event.preventDefault();
                });

            }));

        }

        setupPagination() {
            this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
            if (this.sliderItemsToShow.length < 2) return;

            this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

            this.currentPageElement = this.pagination.querySelector('.slider-counter--current');
            this.currentProgresPageElement = this.pagination.querySelector('.pagination-progress-bar');
            this.pageTotalElement = this.pagination.querySelector('.slider-counter--total');

            this.prevButton = this.pagination.querySelector('button[name="previous"]');
            this.nextButton = this.pagination.querySelector('button[name="next"]');


            this.prevButton.addEventListener('click', this.onPaginationButtonClick.bind(this));
            this.nextButton.addEventListener('click', this.onPaginationButtonClick.bind(this));


            this.updatePagination();
        }

        onPaginationResize() {
            this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
            if (this.sliderItemsToShow.length < 2) return;

            this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
        }

        onPaginationButtonClick(event) {
            event.preventDefault();
            this.slideScrollPosition = event.currentTarget.name === 'next' ? this.scrollLeft + (1 * this.sliderItemOffset) : this.scrollLeft - (1 * this.sliderItemOffset);
            this.scrollTo({
                left: this.slideScrollPosition
            });
        }

        updatePagination() {
            window.setTimeout(() => {

            if (!this.nextButton) return;

            const previousPage = this.currentPage;
            this.currentPage = Math.round(this.scrollLeft / this.sliderItemOffset) + 1;

            if (this.currentPageElement) {
                this.currentPageElement.textContent = this.currentPage;
            }
            if (this.currentProgresPageElement) {
                this.currentProgresPageElement.style.transform = 'translate(' + (this.currentPage - 1) * 100 + '%,0)';
            }
            if (this.currentPage != previousPage) {
                this.dispatchEvent(new CustomEvent('slideChanged', {
                    detail: {
                        currentPage: this.currentPage,
                        currentElement: this.sliderItemsToShow[this.currentPage - 1]
                    }
                }));
            }

            if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.scrollLeft === 0) {
                this.prevButton.setAttribute('disabled', 'disabled');
            } else {
                this.prevButton.removeAttribute('disabled');
            }

            if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
                this.nextButton.setAttribute('disabled', 'disabled');
            } else {
                this.nextButton.removeAttribute('disabled');
            }
            }, 1000);

        }

        isSlideVisible(element, offset = 0) {
            const lastVisibleSlide = this.clientWidth + this.scrollLeft - offset;
            return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.scrollLeft;
        }
    }

    customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
    customElements.define('product-form', class ProductForm extends HTMLElement {
        constructor() {
            super();

            this.sticky = this.dataset.sticky;
            this.form = document.getElementById(`product-form-${this.dataset.section}`);
            this.form.querySelector('[name=id]').disabled = false;
            if (!this.sticky) {
                this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
            }
            this.cartNotification = document.querySelector('cart-notification');
            this.body = document.body;

            this.hideErrors = this.dataset.hideErrors === 'true';
        }

        onSubmitHandler(evt) {
            evt.preventDefault();
            if (!this.form.reportValidity()) {
                return;
            }
            const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

            submitButtons.forEach((submitButton) => {
                if (submitButton.classList.contains('loading')) return;
                submitButton.setAttribute('aria-disabled', true);
                submitButton.classList.add('loading');
            });

            this.handleErrorMessage();


            const config = {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Accept': 'application/javascript'
                }
            };
            let formData = new FormData(this.form);

            formData.append('sections', this.getSectionsToRender().map((section) => section.section));
            formData.append('sections_url', window.location.pathname);
            config.body = formData;

            fetch(`${theme.routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                    if (response.status) {
                        dispatchCustomEvent('product:variant-error', {
                            source: 'product-form',
                            productVariantId: formData.get('id'),
                            errors: response.description,
                            message: response.message
                        });
                        this.handleErrorMessage(response.description);
                        return;
                    }

                    this.renderContents(response);

                    dispatchCustomEvent('cart:item-added', {
                        product: response.hasOwnProperty('items') ? response.items[0] : response
                    });
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                    submitButtons.forEach((submitButton) => {
                        submitButton.classList.remove('loading');
                        submitButton.removeAttribute('aria-disabled');
                    });
                });
        }

        getSectionsToRender() {
            return [{
                id: 'Cart',
                section: 'main-cart',
                selector: '.thb-cart-form'
            },
                {
                    id: 'Cart-Drawer',
                    section: 'cart-drawer',
                    selector: '.cart-drawer'
                },
                {
                    id: 'cart-drawer-toggle',
                    section: 'cart-bubble',
                    selector: '.thb-item-count'
                }];
        }

        renderContents(parsedState) {
            this.getSectionsToRender().forEach((section => {
                if (!document.getElementById(section.id)) {
                    return;
                }
                const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

                if (typeof CartDrawer !== 'undefined') {
                    new CartDrawer();
                }
                if (typeof Cart !== 'undefined') {
                    new Cart().renderContents(parsedState);
                }
            }));


            let product_drawer = document.getElementById('Product-Drawer');
            if (product_drawer && product_drawer.contains(this)) {
                product_drawer.querySelector('.product-quick-images--container').classList.remove('active');
                document.body.classList.remove('open-quick-view');

                if (window.innerWidth < 1069) {
                    product_drawer.classList.remove('active');
                    if (document.getElementById('Cart-Drawer')) {
                        document.getElementById('Cart-Drawer').classList.add('active');
                        document.body.classList.add('open-cart');
                        document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
                        dispatchCustomEvent('cart-drawer:open');
                    }
                } else {
                    product_drawer.querySelector('.product-quick-images--container').addEventListener('transitionend', function () {
                        product_drawer.classList.remove('active');

                        if (document.getElementById('Cart-Drawer')) {
                            document.getElementById('Cart-Drawer').classList.add('active');
                            document.body.classList.add('open-cart');
                            document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
                            dispatchCustomEvent('cart-drawer:open');
                        }
                    });
                }

                if (!document.getElementById('Cart-Drawer')) {
                    document.body.classList.remove('open-cc');
                }
            } else if (document.getElementById('Cart-Drawer')) {
                document.body.classList.add('open-cc');
                document.body.classList.add('open-cart');
                document.getElementById('Cart-Drawer').classList.add('active');
                dispatchCustomEvent('cart-drawer:open');
            }
        }

        getSectionInnerHTML(html, selector = '.shopify-section') {
            return new DOMParser()
                .parseFromString(html, 'text/html')
                .querySelector(selector).innerHTML;
        }

        handleErrorMessage(errorMessage = false) {
            if (this.hideErrors) return;
            this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
            this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

            this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

            if (errorMessage) {
                this.errorMessage.textContent = errorMessage;
            }
        }
    });
}


/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
    class ProductAddToCartSticky extends HTMLElement {
        constructor() {
            super();

            this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
        }

        connectedCallback() {
            this.setupObservers();
            this.setupToggle();
        }

        setupToggle() {
            const button = this.querySelector('.product-add-to-cart-sticky--inner'),
                content = this.querySelector('.product-add-to-cart-sticky--content');

            if (this.animations_enabled) {
                const tl = gsap.timeline({
                    reversed: true,
                    paused: true,
                    onStart: () => {
                        button.classList.add('sticky-open');
                    },
                    onReverseComplete: () => {
                        button.classList.remove('sticky-open');
                    }
                });

                tl
                    .set(content, {
                        display: 'block',
                        height: 'auto'
                    }, 'start')
                    .from(content, {
                        height: 0,
                        duration: 0.25
                    }, 'start+=0.001');

                button.addEventListener('click', function () {
                    tl.reversed() ? tl.play() : tl.reverse();

                    return false;
                });
            } else {
                button.addEventListener('click', function () {
                    content.classList.toggle('active');
                    return false;
                });
            }


        }

        setupObservers() {
            let _this = this,
                observer = new IntersectionObserver(function (entries) {
                    entries.forEach((entry) => {
                        if (entry.target === footer) {
                            if (entry.intersectionRatio > 0) {
                                _this.classList.remove('sticky--visible');
                            } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                                _this.classList.add('sticky--visible');
                            }
                        }
                        if (entry.target === form) {
                            let boundingRect = form.getBoundingClientRect();

                            if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                                _this.formPassed = true;
                                _this.classList.add('sticky--visible');
                            } else if (entry.intersectionRatio === 1) {
                                _this.formPassed = false;
                                _this.classList.remove('sticky--visible');
                            }
                        }
                    });
                }, {
                    threshold: [0, 1]
                }),
                form = document.getElementById(`product-form-${this.dataset.section}`),
                footer = document.getElementById('footer');
            _this.formPassed = false;
            observer.observe(form);
            observer.observe(footer);
        }
    }

    customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get('side-panel-links')) {
    class ProductSidePanelLinks extends HTMLElement {
        constructor() {
            super();
            this.links = this.querySelectorAll('button');
            this.drawer = document.getElementById('Product-Information-Drawer');
            this.buttons = this.drawer.querySelector('.side-panel-content--tabs');
            this.panels = this.drawer.querySelector('.side-panel-content--inner').querySelectorAll('.side-panel-content--tab-panel');
            this.body = document.body;
        }

        connectedCallback() {
            this.setupObservers();
        }

        disconnectedCallback() {

        }

        setupObservers() {
            this.links.forEach((item, i) => {
                item.addEventListener('click', (e) => {
                    this.body.classList.add('open-cc');
                    this.buttons.toggleActiveClass(i);
                    this.drawer.classList.add('active');
                });
            });
        }
    }

    customElements.define('side-panel-links', ProductSidePanelLinks);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
    addIdToRecentlyViewed();
}


/*
if (!customElements.get('add_product_shortcut')) {
  /**
   *  @class
   *  @function AddProductShortcut
   *
  class AddProductShortcut extends HTMLElement {
    constructor() {
      super();
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.buttons = document.querySelector('.plus-button');
      this.input = document.querySelector('.add_to_cart_holder .qty');
    }
    connectedCallback() {
      this.setupObservers();
    }
    addToCart(qty){
      this.input.value = qty;
      this.form.submit();
    }
    setupObservers() {
      let _this = this;
      
      this.buttons.addEventListener('click', (e) => {
        if(e.target.classList.contains('plus2')){
          this.addToCart(2);
        }
        if(e.target.classList.contains('plus3')){
          this.addToCart(3);
        }
      });
        
      this.input.addEventListener('change', (e) => {
        quantity = e.target.value;
        if(quantity == 2 || quantity == 3){
          if(quantity == 2){
            let button = document.querySelector('.plus-button.plus2');
          }
          if(quantity == 3){
            let button = document.querySelector('.plus-button.plus3');
          }
          this.buttons.toggleActiveClass(button);
        }
      });
    }
  }

  customElements.define('add_product_shortcut', AddProductShortcut);
}
*/

function checkAppstleSubscription() {

    const currentUrl = window.location.href;

    // Define las rutas permitidas para cada idioma
    const allowedPaths = [
        // España
        'com/products/',
        // Uk
        'co.uk/products/',
        // Francia
        'fr/products/',
        // Alemania
        'de/products/',
        // Portugal
        'pt/products/',
        // Polonia
        'pl/products',
        // Italia
        'it/products',
        // Netherlands
        'nl/products',
        // Preview
        'products_preview'
    ];

    const translations = {
        'com': { no: 'No', save: 'Ahorrar 10% extra', on_sale: 'Oferta' },
        'co.uk': { no: 'No', save: 'Save 10% extra', on_sale: 'Sale' },
        'fr': { no: 'Non', save: 'Économiser 10%', on_sale: 'Offre' }, 
        'de': { no: 'Nein', save: '10% extra sparen', on_sale: 'Angebot' },
        'pt': { no: 'Não', save: 'Poupar 10% extra', on_sale: 'Oferta' },
        'pl': { no: 'Nie', save: 'Oszczędź dodatkowo 10%', on_sale: 'Oferta'},
        'it': { no: 'No', save: 'Risparmia il 10% in più', on_sale: 'Offerta'},
        'nl': { no: 'Nee', save: 'Bespaar 10% extra', on_sale: 'Aanbod'}
    };

    const matchedPath = allowedPaths.find(path => currentUrl.includes(path));
    if (!matchedPath) {
        return; 
    }

    const domain = matchedPath.split('/')[0];
    const translation = translations[domain];

    const targetNode = document.querySelector('.product-add-to-cart-container');

    const config = { childList: true, subtree: true };

    const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                const appstleWidget = document.querySelector('.appstle_sub_widget');
                if (appstleWidget) {
                    
                    observer.disconnect();

                    const oneTimeTextElement = appstleWidget.querySelector('.appstle_one_time_text');
                    const monthTextElement = appstleWidget.querySelector('.appstle-text-and-badge-wrapper');
                    const toggleAppsle = appstleWidget.querySelector('.appstle_subscribe_option_grid');
                    const subscriptionWrapper = appstleWidget.querySelector('.appstle_subscription_wrapper');
                    const morePopularDiv = document.getElementById('ph-more-popular');
                    const moreSaveDiv = document.getElementById('ph-more-save');
                    const hasSelectedPlan = appstleWidget.hasAttribute('data-selected-selling-plan');
                    const saveBagde = document.querySelector('.appstle_subscription_save');

                    if (oneTimeTextElement) {
                        oneTimeTextElement.textContent = translation.no;
                    }
                    if (monthTextElement) {
                        monthTextElement.textContent = translation.save;
                        monthTextElement.classList.add('ph-appstle-label');
                    }
                    if (toggleAppsle) {
                        toggleAppsle.classList.add('ph-appstle-toggle');
                    }
                    if (subscriptionWrapper) {
                        subscriptionWrapper.classList.add('ph-subscription-wrapper');
                    }
  
                    if (morePopularDiv) {
                        morePopularDiv.classList.toggle('ph-show-badge', !hasSelectedPlan);
                    }

                    if (moreSaveDiv) {
                        moreSaveDiv.classList.toggle('ph-show-badge', hasSelectedPlan);
                    }

                    if (saveBagde) {
                        saveBagde.textContent = translation.on_sale;
                    }
                  

                    observer.observe(targetNode, config);

                }
            }
        }
    });

    if (targetNode) {
        observer.observe(targetNode, config);
    }
}


checkAppstleSubscription();